'use client'

import { useEffect, useState } from 'react'

const LINE_1 = 'Content zaczyna się'
const LEAD_2 = 'od '
const ACCENT_2 = 'dobrego FLOU.'
const TOTAL = LINE_1.length + LEAD_2.length + ACCENT_2.length

/**
 * „Content zaczyna się / od dobrego FLOU." typing itself in — no caret.
 *
 * The comp's mechanics exactly: 450ms before the first letter, then one letter
 * every 62ms. Each line is a grid of two copies, the full text invisible and
 * the typed slice over it, so the block holds its final size from the first
 * frame and nothing below it moves while it types.
 */
export function TypedTitle() {
  const [n, setN] = useState(0)

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setN(TOTAL)
      return
    }
    let timer: ReturnType<typeof setInterval> | undefined
    const start = setTimeout(() => {
      timer = setInterval(() => {
        setN((was) => {
          if (was + 1 >= TOTAL && timer) clearInterval(timer)
          return Math.min(TOTAL, was + 1)
        })
      }, 62)
    }, 450)
    return () => {
      clearTimeout(start)
      if (timer) clearInterval(timer)
    }
  }, [])

  const n2 = Math.max(0, n - LINE_1.length)

  return (
    <h2
      className="fh-m fh-h1"
      style={{ margin: 0, fontSize: 'clamp(3.6rem, 4.6vw, 6rem)', lineHeight: 1, fontWeight: 700 }}
    >
      <span className="sr-only">Content zaczyna się od dobrego FLOU.</span>
      <span className="fh-tw-line" aria-hidden="true">
        <span className="fh-tw-ghost">{LINE_1}</span>
        <span>{LINE_1.slice(0, Math.min(n, LINE_1.length))}</span>
      </span>
      <br />
      <span className="fh-tw-line" aria-hidden="true">
        <span className="fh-tw-ghost">
          {LEAD_2}
          {ACCENT_2}
        </span>
        <span>
          {LEAD_2.slice(0, n2)}
          <span className="fh-flou-word">{ACCENT_2.slice(0, Math.max(0, n2 - LEAD_2.length))}</span>
        </span>
      </span>
    </h2>
  )
}
